
export function tlaToClientCode(tla:string) {
    let len = tla.length;
    if (len < 3 || len > 4) {
      return undefined;
    }
    let tlaParts = tla.toUpperCase().split('');
    let value = tlaParts.map(a => a.charCodeAt(0)).reduce(((previous, current) => previous + current), '80') + '00';
    return value.slice(0, 10);
};
  